import { LockKeyhole } from 'lucide-react';

export const inviteError = (error, fallback = 'Could not complete this action') => {
  const detail = error.response?.data?.detail;
  return typeof detail === 'string' ? detail : detail?.message || fallback;
};

export function InvitationGate({ setup }) {
  return <section className="border-l-4 border-amber-500 bg-amber-500/5 p-4 space-y-2" role="status" data-testid="invitation-send-gate">
    <h2 className="flex gap-2 items-center font-semibold text-base" data-testid="invitation-gate-title"><LockKeyhole className="h-4 w-4" />Sending locked</h2>
    <p className="text-sm" data-testid="invitation-gate-explanation">You can review patients, prepare drafts and approve policies. No invitations or verification messages will be sent while managed signup is unavailable.</p>
    <ul className="text-xs text-muted-foreground space-y-1">{setup?.blockers?.map((reason, index) => <li key={reason} data-testid={`invitation-blocker-${index}`}>{reason}</li>)}</ul>
  </section>;
}